// Misc
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

// Atoms
import Link from './Link'

// Styles
const styles = theme => ({
  root: {
    ...theme.typography.body2,
    textDecoration: 'none',
    outline: 0,
    '&:hover': {
      textDecoration: 'underline'
    },
  },
  primary: {
    color: theme.palette.primary.dark,
  },
  secondary: {
    color: theme.palette.secondary.main,
  }
})

const StyledLink = ({ classes, className, color, ...rest }) => (
  <Link
    tabIndex="-1"
    className={classNames(classes.root, classes[color], className)}
    {...rest}
  />
)

StyledLink.defaultProps = {
  color: 'primary',
}

StyledLink.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.any,
  color: PropTypes.oneOf(['primary', 'secondary']),
}

export default withStyles(styles)(StyledLink)
